const MAGIC = "IMAGEWTY";
const HEADER_SIZE = 0x60;
const ITEM_ENTRY_SIZE = 0x400;

function readCString(dataView, offset, maxLen) {
  const bytes = [];
  for (let i = 0; i < maxLen; i++) {
    const b = dataView.getUint8(offset + i);
    if (b === 0) break;
    bytes.push(b);
  }
  return String.fromCharCode(...bytes);
}

function parseHeader(dataView) {
  const magic = readCString(dataView, 0x00, 8);
  if (magic !== MAGIC) {
    throw new Error(`Invalid magic: expected "${MAGIC}", got "${magic}"`);
  }

  const headerVersion = dataView.getUint32(0x08, true);
  const headerSize = dataView.getUint32(0x0c, true);
  const imageSize = dataView.getUint32(0x18, true);
  const itemTableOffset = dataView.getUint32(0x20, true);
  const itemEntrySize = dataView.getUint32(0x38, true);
  const itemCount = dataView.getUint32(0x3c, true);

  if (headerSize !== HEADER_SIZE) {
    throw new Error(`Unexpected header size: 0x${headerSize.toString(16)} (expected 0x${HEADER_SIZE.toString(16)})`);
  }

  if (itemEntrySize !== ITEM_ENTRY_SIZE) {
    throw new Error(`Unexpected item entry size: 0x${itemEntrySize.toString(16)} (expected 0x${ITEM_ENTRY_SIZE.toString(16)})`);
  }

  return { magic, headerVersion, headerSize, imageSize, itemTableOffset, itemEntrySize, itemCount };
}

function parseItem(dataView, buffer, entryOffset) {
  const bufferLen = buffer.byteLength;

  if (entryOffset + ITEM_ENTRY_SIZE > bufferLen) {
    throw new Error(`Item entry at 0x${entryOffset.toString(16)} exceeds buffer length`);
  }

  const mainType = dataView.getUint32(entryOffset + 0x000, true);
  const subType = dataView.getUint32(entryOffset + 0x004, true);
  const name = readCString(dataView, entryOffset + 0x008, 32);
  const filename = readCString(dataView, entryOffset + 0x028, 64);
  const dataLen = dataView.getUint32(entryOffset + 0x124, true);
  const origLen = dataView.getUint32(entryOffset + 0x12c, true);
  const dataOffset = dataView.getUint32(entryOffset + 0x134, true);

  if (dataOffset + dataLen > bufferLen) {
    throw new Error(`Item "${name}" data region [0x${dataOffset.toString(16)}..0x${(dataOffset + dataLen).toString(16)}] exceeds buffer length (0x${bufferLen.toString(16)})`);
  }

  const data = new Uint8Array(buffer, dataOffset, dataLen);

  return { name, filename, mainType, subType, dataOffset, dataLen, origLen, data };
}

export function parseImageWTY(arrayBuffer) {
  if (!arrayBuffer || arrayBuffer.byteLength < HEADER_SIZE) {
    throw new Error(`Buffer too small: need at least ${HEADER_SIZE} bytes, got ${arrayBuffer ? arrayBuffer.byteLength : 0}`);
  }

  const dataView = new DataView(arrayBuffer);
  const header = parseHeader(dataView);

  const items = [];
  for (let i = 0; i < header.itemCount; i++) {
    const entryOffset = header.itemTableOffset + i * header.itemEntrySize;
    items.push(parseItem(dataView, arrayBuffer, entryOffset));
  }

  return { header, items };
}

export function findItem(items, namePattern) {
  const pattern = namePattern.toLowerCase();
  return items.find((item) => item.name.toLowerCase().includes(pattern));
}

export function getItemsByRole(items) {
  return {
    fes: findItem(items, "FES_1"),
    boot0: findItem(items, "BOOT0"),
    uboot: findItem(items, "UBOOT"),
    fullimg: findItem(items, "FULLIMG"),
    mbr: findItem(items, "MBR"),
    kernel: findItem(items, "KERNEL"),
    bootResource: findItem(items, "BOOT-RESOURCE"),
    env: findItem(items, "ENV"),
    script: findItem(items, "SCRIPT"),
    dlinfo: findItem(items, "DLINFO"),
  };
}
